import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_GraphColoring = () => (
  <DAAModuleSubtopic
    title="Graph Coloring Problem - Backtracking"
    videos={[
      "https://www.youtube.com/embed/Lm378j0CuYM?list=PL8xmnXn7pVtwcQRtWxhyGA7OfmGcNBsbv",
      "https://www.youtube.com/embed/052VkKhIaQ4",
    ]}
    takeaways={[
      { text: "Worst-case Time Complexity: O(m^n) (exponential)." },
      { text: "Space Complexity: O(n) (for storing color assignments)." },
      { text: "Backtracking explores all possibilities and prunes invalid ones." },
      { text: "Effective for small graphs but inefficient for large graphs." },
      { text: "The algorithm can be optimized using heuristics like MRV (Minimum Remaining Values)." },
    ]}
    questions={[
      {
        text: "Graph coloring is the procedure of assignment of colors to each vertex of a graph such that no adjacent vertices get the same color. Design an algorithm for this problem by applying a backtracking method and color the below graph using red, yellow, and blue (m=3). Show any 10 possible solutions in the state space tree.",
        image: "/graphq1.png",
      },
      {
        text: "Enumerate the possible solutions for coloring the vertices in the below graph using three colors (RGB) using the backtracking approach.",
        image: "/graphQ2.png",
      },
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/TzTehRk1OQs",
      "https://www.youtube.com/embed/FunWLjE9Plw",
    ]}
  />
);

export default DAA_GraphColoring ;
